// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__4C1CJ","text":"SelectPayment_text__3GLbQ","title":"SelectPayment_title__1oXDM","btn":"SelectPayment_btn__3u7kj"};